var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { IconButton, Typography, Box } from '@mui/material';
import DetailIconWithText from '../../atoms/DownloadIconWithtext';
import { useNavigate } from 'react-router-dom';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-wrap: wrap;\n"], ["\n  flex-wrap: wrap;\n"])));
var ContractsList = function (_a) {
    var _b = _a.offerList, salesContract = _b.salesContract, _c = _b.shippingInstructions, shippingInstructions = _c === void 0 ? [] : _c;
    var t = useTranslation().t;
    var navigate = useNavigate();
    if (!salesContract && shippingInstructions.length === 0)
        return React.createElement(Typography, null, t('labels.noData'));
    return (React.createElement(Wrapper, null,
        salesContract && (React.createElement(Box, null,
            React.createElement(Typography, { variant: "h6" }, 'Sales Contract / Auction Bonus Invoice'),
            React.createElement(IconButton, { onClick: function () {
                    return navigate("/admin/sales_contracts/".concat(salesContract.id));
                } },
                React.createElement(DetailIconWithText, { title: "" })))),
        React.createElement(Box, null,
            React.createElement(Typography, { variant: "h6" }, 'Shipping Instruction / Commercial Invoice / Packing List'),
            shippingInstructions.map(function (shippingInstruction) { return (React.createElement(IconButton, { key: shippingInstruction.id, onClick: function () {
                    return navigate("/admin/shipping_instructions/".concat(shippingInstruction.id));
                } },
                React.createElement(DetailIconWithText, { title: "".concat(shippingInstruction.warehouseName) }))); }))));
};
export default ContractsList;
var templateObject_1;
